export default class PetConcern {}

PetConcern.Allergies = 'ALLERGIES';
PetConcern.FleaAndTick = 'FLEA_AND_TICK';
